import FooterCTA from "./FooterCTA";
import MessageSection from "./MessageSection";

import ScrollRevealSubFooter from "./ScrollRevealSubFooter";

const FooterSection = () => {
  return (
    <>
      <div className="relative z-[100] bg-gray-900" id="about-me-section">
        <div className="pb-24">
          {/* centre footer section */}
          <div className="py-20 sm:py-40 flex justify-center md:mr-40">
            <MessageSection />
          </div>
          {/* footer section cta */}
          <FooterCTA />
        </div>
      </div>
      <ScrollRevealSubFooter />
    </>
  );
};

export default FooterSection;
